import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, useFormContext } from 'react-hook-form';
import MultiSelect, { type MultiSelectProps } from '../../multi-select';
import type { LabelTooltipProps } from '../internals/form-label';
import FormWrapper from '../internals/form-wrapper';
export type FormMultiSelectProps<TFieldValues extends FieldValues> = {
  id?: string;
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: ControllerProps<TFieldValues>['rules'];
  hint?: string;
  tooltip?: LabelTooltipProps;
  size?: 'default' | 'compact';
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal';
  onChange?: (value: string[]) => void;
} & Omit<MultiSelectProps, 'value' | 'onChange' | 'onBlur' | 'ref' | 'label' | 'hasError'>;
export default function FormMultiSelect(t0) {
  const $ = _c(25);
  let baseId;
  let hint;
  let label;
  let multiSelectProps;
  let name;
  let rules;
  let t1;
  let t2;
  let t3;
  let tooltip;
  if ($[0] !== t0) {
    ({
      name,
      label,
      rules,
      hint,
      tooltip,
      id: baseId,
      size: t1,
      errorPosition: t2,
      orientation: t3,
      ...multiSelectProps
    } = t0);
    $[0] = t0;
    $[1] = baseId;
    $[2] = hint;
    $[3] = label;
    $[4] = multiSelectProps;
    $[5] = name;
    $[6] = rules;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = tooltip;
  } else {
    baseId = $[1];
    hint = $[2];
    label = $[3];
    multiSelectProps = $[4];
    name = $[5];
    rules = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    tooltip = $[10];
  }
  const size = t1 === undefined ? "default" : t1;
  const errorPosition = t2 === undefined ? "relative" : t2;
  const orientation = t3 === undefined ? "vertical" : t3;
  const {
    control
  } = useFormContext();
  const contextId = useId();
  const id = baseId || contextId;
  let t4;
  if ($[11] !== errorPosition || $[12] !== hint || $[13] !== id || $[14] !== label || $[15] !== multiSelectProps || $[16] !== orientation || $[17] !== size || $[18] !== tooltip) {
    t4 = t5 => {
      const {
        field,
        fieldState
      } = t5;
      const error = fieldState.error?.message;
      return <FormWrapper id={id} error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} tooltip={tooltip} orientation={orientation} fullWidth={true} disabled={multiSelectProps.disabled || field.disabled}><MultiSelect {...multiSelectProps} {...field} onChange={e => {
          field.onChange(e);
          multiSelectProps.onChange?.(e);
        }} hasError={!!error} size={size} disabled={field.disabled || multiSelectProps.disabled} data-dd-privacy="mask" /></FormWrapper>;
    };
    $[11] = errorPosition;
    $[12] = hint;
    $[13] = id;
    $[14] = label;
    $[15] = multiSelectProps;
    $[16] = orientation;
    $[17] = size;
    $[18] = tooltip;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== control || $[21] !== name || $[22] !== rules || $[23] !== t4) {
    t5 = <Controller name={name} control={control} rules={rules} render={t4} />;
    $[20] = control;
    $[21] = name;
    $[22] = rules;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
}